<template>
    <div>
        <loading :loading="loading"></loading>
        <div v-if="message" class="show-message">
            <ion-avatar class="big-avatar" v-on:click="viewUser(message.message.user.id)">
                <img :src="message.message.user.avatar" v-if="message.message.user.avatar">
                <img src="../../assets/ghost-avatar-white.png" class="dark-img" v-else>
            </ion-avatar>
            <div v-if="playing">
                <div class="message-details">
                    Call from {{message.message.user.name}}
                </div>
                <div class="row message-icons u-mb1">
                    <audio autoplay controls v-on:ended="hideCall()">
                        <source :src="message.message.path" :type="message.message.mime">
                    </audio>
                    <div class="col-12 u-mt1">
                        <ion-button shape="round" v-on:click="hideCall()" color="medium" style="color : var(--ion-color-dark);">
                            Close
                        </ion-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="message-details">
                    Call from {{message.message.user.name}}
                    is waiting
                </div>
                <div class="row message-icons">
                    <audio autoplay loop>
                        <source src="../../assets/phone-loop.mp3" type="audio/mp3">
                    </audio>
                    <div class="col-6" v-on:click="hideCall()">
                        <ion-icon name="close-circle" color="danger"></ion-icon>
                    </div>
                    <div class="col-6" v-on:click="playCall()">
                        <ion-icon name="play-circle" color="success"></ion-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {auth} from '../../mixins/auth';
import {userdetails} from '../../mixins/userdetails';
import {formatting} from '../../mixins/formatting';
import ReturnHome from '@/components/ReturnHome.vue';
import Refresh from '@/components/Refresh.vue';
import Loading from '@/components/Loading.vue';
import Logo from '@/components/Logo.vue';
import _ from 'lodash';

export default {
    name : 'Call',
    mounted : function () {
        this.getMessage();
    },
    mixins : [auth, userdetails, formatting],
    components : {
        ReturnHome, Logo, Refresh, Loading
    },
    data : function () {
        return {
            complete : false,
            loading  : false,
            refreshing : false,
            message    : null,
            playing    : false
        }
    },
    methods : {
        callsPage : function () {
            this.$router.replace({name : 'calls'});
        },
        getMessage : function () {
            let self = this;
            this.loading = true;
            if (this.$route.params.id) {
                this.axios.get(this.api + 'messages/' + this.$route.params.id + '/view')
                    .then(response => {
                        // open it if it exists
                        self.loading = false;
                        self.showCall(response.data);
                    })
                    .catch(error => {
                        self.callsPage();
                    });
            } else {
                this.callsPage();
            }
        },
        viewUser : function (id) {
            this.$router.push({name : 'user', params : {id : id}});
        },
        back : function () {
            this.$router.push({name : 'calls'});
        },
        messageViewed : function () {
            let self = this;
            if (!this.message) {
                console.debug('no message to view');
                return;
            }
            this.axios.post(this.api + 'messages/' + this.message.message_id + '/viewed')
                .then(() => {
                    self.message.viewed_at = true;
                })
                .catch(error => {
                    console.error('Error setting message as viewed', error);
                })
        },
        showCall : function (message) {
            this.$root.closeMenu();
            this.message = message;
        },
        playCall : function () {
            this.playing = true;
            this.messageViewed();
        },
        hideCall : function () {
            this.message = null;
            this.playing = false;
            this.callsPage();
        }
    }
}
</script>

<style>
.call-container.-viewed {
    background-color : #6596af;
}
.show-message {
    position: fixed;
    top: -50px;
    left: 0;
    width: 100%;
    height: calc(100vh + 50px);
    background: var(--ion-color-dark);
    color: var(--ion-color-dark-contrast);
    z-index: 20000;
    padding : 5rem 1rem;
}
.message-details {
    padding : 2rem;
    font-weight : 900;
    font-size: 36px;
    line-height: 50px;
}
.message-icons {
    font-weight : 900;
    font-size: 36px;
    line-height: 44px;
}
.message-icons ion-icon {
    width : 96px;
    height : 96px;
    background: white;
    padding: 0;
    border-radius: 48px;
    margin: 0;
}
.message-icons ion-icon.ion-color-success.hydrated {
    animation: bigpulse 3s infinite;
}
.message-icons audio {
    width : 90%;
    margin : 10px auto;
}
</style>